$(document).ready(function () {

    var isMobile = window.innerWidth <= 767;

    $(".BV1_rest_section .custom-flex_item_ad_inner").each(function () {

        var $block = $(this);

        $block.find(".new_faq_wrapper_top, .new_faq_wrapper_top_right, .new_faq_wrapper_bottom").remove();

        var $img     = $block.find(".BV1_rest_img");
        var $rating  = $block.find(".BV1_rest_rating");
        var $heading = $block.find(".BV1_rest_heading");
        var $price   = $block.find(".BV1_rest_price");
        var $list1   = $block.find(".BV1_rest_list1");
        var $button  = $block.find(".BV1_rest_button");

        if (!isMobile) {

            var $top = $('<div class="new_faq_wrapper_top"></div>');
            var $bottom = $('<div class="new_faq_wrapper_bottom"></div>');

            $top.append($img)
                .append($rating)
                .append($heading);

            $bottom.append($price)
                   .append($list1)
                   .append($button);

            $block.prepend($top);
            $block.append($bottom);

        } else {

            // -----------------------------------------------------
            // MOBILE (Corrected Structure)
            // -----------------------------------------------------

            var $top = $('<div class="new_faq_wrapper_top"></div>');
            var $topRight = $('<div class="new_faq_wrapper_top_right"></div>');
            var $bottom = $('<div class="new_faq_wrapper_bottom"></div>');

            // RIGHT PART (only rating, heading, price)
            $topRight.append($rating)
                     .append($heading)
                     .append($price);

            // TOP WRAPPER — image + right group inside it
            $top.append($img)
                .append($topRight);

            // Bottom
            $bottom.append($list1)
                   .append($button);

            // Insert into block
            $block.prepend($top);
            $block.append($bottom);
        }

    });

});



$(document).on("click", ".new_faq_wrapper_top", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.new_faq_wrapper_top').removeClass('active');
    jQuery('.new_faq_wrapper_top').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});